var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCardInfoLoading)?_c('div',{staticClass:"loader"},[_c('loading-icon',{staticClass:"--primary"})],1):(_vm.cardsPayment && _vm.cardsPayment.length)?_c('div',_vm._l((_vm.cardsPayment),function(card,index){return _c('details-card-payment',{key:index,attrs:{"card":card}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }